<div class="notification-toast">
  <span class="toast-icon">
    <mat-icon>{{data.icon}}</mat-icon>
  </span>
  <span class="toast-label">{{ data.labelKey | translate: data.labelParams }}</span>
  <button mat-icon-button class="toast-close" (click)="snackBarRef.dismiss()">
    <mat-icon>close</mat-icon>
  </button>
</div>
